import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { featureEnabled, paramaterize } from 'utils';

import Button from '../../Button';
import Icon from '../../Icon';
import Space from '../../Space';

export type AppointmentPermission = {
  attempted: boolean;
  cancel: boolean;
  confirm: boolean;
  deny: boolean;
  new: boolean;
  time_change: boolean;
};

type AppointmentItemActionsProps = {
  appointmentId: string;
  permission?: AppointmentPermission;
  team?: boolean;
  listingId?: string;
};

const AppointmentItemActions: React.FC<AppointmentItemActionsProps> = ({
  appointmentId,
  permission,
  team,
  listingId,
}) => {
  if (!permission) {
    return null;
  }

  const showingsCalendarUrl =
    team && listingId
      ? `listing/${listingId}/showings`
      : 'my_business/showings/listing';

  return (
    <Space size={6}>
      {permission.confirm && (
        <Link
          to={
            featureEnabled('showingDetailsRevampFeaturePhase', 3)
              ? `my_business/showing/${appointmentId}?${paramaterize({
                  redirectTo: 'calendar',
                  isListingAgent: true,
                  status: 'confirm',
                })}`
              : `${showingsCalendarUrl}?${paramaterize({
                  appointmentId,
                  action: 'confirm',
                })}`
          }
          key={`confirm-${appointmentId}`}
          data-cy={`confirm-${appointmentId}`}
        >
          <SlimButton
            icon={
              <Icon
                type="antdCheckOutlined"
                width={12}
                offset={[0, -2]}
                color="gray8"
              />
            }
          >
            Accept
          </SlimButton>
        </Link>
      )}
      {permission.deny && (
        <Link
          to={
            featureEnabled('showingDetailsRevampFeaturePhase', 3)
              ? `my_business/showing/${appointmentId}?${paramaterize({
                  redirectTo: 'calendar',
                  isListingAgent: true,
                  status: 'deny',
                })}`
              : `${showingsCalendarUrl}?${paramaterize({
                  appointmentId,
                  action: 'deny',
                  team,
                })}`
          }
          key={`deny-${appointmentId}`}
          data-cy={`deny-${appointmentId}`}
        >
          <SlimButton
            icon={
              <Icon
                type="antdCloseOutlined"
                width={12}
                offset={[0, -2]}
                color="gray8"
              />
            }
          >
            Deny
          </SlimButton>
        </Link>
      )}
      {permission.time_change && (
        <Link
          to={`appointments/${appointmentId}/time_change_contact?${paramaterize(
            {
              redirectTo: team ? 'listingCalendar' : 'calendar',
              toast: 'time_change_suggested',
            },
          )}`}
          key={`time-change-${appointmentId}`}
          data-cy={`suggest-${appointmentId}`}
        >
          <SlimButton
            icon={
              <Icon
                type="antdClockCircle"
                width={12}
                offset={[0, -2]}
                color="gray8"
              />
            }
          >
            Suggest
          </SlimButton>
        </Link>
      )}
    </Space>
  );
};

export default AppointmentItemActions;

const SlimButton = styled(Button).attrs({ size: 'small' })`
  padding-left: 6px;
  > .anticon + span {
    margin-left: 5px;
  }
`;
